import { REDUCED_MOTION } from '@utils/Motion';
import { gsap } from 'gsap';

const DURATION = 0.45;
const EASE = 'expo.out';

// Items still showing while their close animation runs; a click on one re-opens it.
const closingItems = new WeakSet<HTMLDetailsElement>();

function toggleItem(item: HTMLDetailsElement, summary: HTMLElement, answer: HTMLElement) {
    const opening = !item.open || closingItems.has(item);
    const startHeight = item.offsetHeight;

    gsap.killTweensOf(item, 'height');
    gsap.killTweensOf(answer);
    closingItems.delete(item);

    if (opening) {
        item.open = true;
        gsap.set(item, { height: 'auto' });
        gsap.fromTo(item, { height: startHeight }, { height: item.offsetHeight, duration: DURATION, ease: EASE, clearProps: 'height' });
        gsap.fromTo(answer, { autoAlpha: 0 }, { autoAlpha: 1, duration: DURATION, ease: EASE, clearProps: 'opacity,visibility' });

        return;
    }

    const borderHeight = item.offsetHeight - item.clientHeight;

    closingItems.add(item);
    gsap.to(answer, { autoAlpha: 0, duration: DURATION / 2, ease: EASE });
    gsap.fromTo(item, { height: startHeight }, {
        height: summary.offsetHeight + borderHeight,
        duration: DURATION,
        ease: EASE,
        onComplete: () => {
            item.open = false;
            closingItems.delete(item);
            gsap.set(item, { clearProps: 'height' });
            gsap.set(answer, { clearProps: 'opacity,visibility' });
        },
    });
}

export function initAccordions() {
    if (REDUCED_MOTION) {
        return;
    }

    document.querySelectorAll<HTMLDetailsElement>('.accordion__item').forEach(item => {
        const summary = item.querySelector<HTMLElement>('.accordion__question');
        const answer = item.querySelector<HTMLElement>('.accordion__answer');

        if (!summary || !answer) {
            return;
        }

        summary.addEventListener('click', event => {
            event.preventDefault();
            toggleItem(item, summary, answer);
        });
    });
}
